import { render, staticRenderFns } from "./ViewHistory.vue?vue&type=template&id=cd615450"
import script from "./ViewHistory.vue?vue&type=script&lang=js"
export * from "./ViewHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports